"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import getOpenReplayTracker from "@/plugins/open-replay";
import { SessionIdUtil } from "@amerisave/amc-client-beacon";
import { saveReplay } from "@/services/backend-service";
const useReplays = otherId => {
  const $ = _c(8);
  const [sessionId, setSessionId] = useState("");
  const [sessionUrl, setSessionUrl] = useState("");
  let t0;
  if ($[0] !== otherId) {
    t0 = async () => {
      const newSessionId = `${new SessionIdUtil().get()}${otherId ? `-${otherId}` : ""}`;
      const openReplayTracker = await getOpenReplayTracker();
      await openReplayTracker.start({
        userID: newSessionId
      });
      const newSessionUrl = openReplayTracker.getSessionURL();
      if (!newSessionUrl) {
        return;
      }
      saveReplay({
        sessionId: newSessionId,
        sessionUrl: newSessionUrl
      });
      setSessionId(newSessionId);
      setSessionUrl(newSessionUrl);
    };
    $[0] = otherId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const startSession = t0;
  let t1;
  if ($[2] !== startSession) {
    t1 = () => {
      startSession();
    };
    $[2] = startSession;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== sessionId || $[6] !== sessionUrl) {
    t3 = {
      sessionId,
      sessionUrl
    };
    $[5] = sessionId;
    $[6] = sessionUrl;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default useReplays;